import Axios from '../utils/axios-utils';

// create notifications
export const createNotifications = async (data, accountId) => {
    try {
        const response = await Axios.post(`/accounts/${accountId}/notifications`, {
            type: data.type,
        });

        return { success: response.data.status === 'success', data: response.data };
    } catch (error) {
        console.log("Create notification error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Create notification failed" }
        };
    }
};

// get all Notifications
export const getAllNotifications = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/notifications`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Notifications error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Notifications failed" }
        };
    }
};


// get all Notification types
export const getAllNotificationTypes = async (accountId) => {
    try {
        const response = await Axios.get(`/accounts/${accountId}/notifications/types`);

        return {
            success: response.data.status === 'success',
            data: response.data,
        };
    } catch (error) {
        console.log("Get All Notifications types error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Get All Notifications types failed" }
        };
    }
};

// delete notification
export const deleteNotification = async (accountId, notificationId) => {
    try {
        const response = await Axios.delete(`/accounts/${accountId}/notifications/${notificationId}`);

        console.log("res : ", response)

        return {
            success: response.data.status === 'success',
            data: response.data,
            status: response.status
        };
    } catch (error) {
        console.log("Delete Notification error:", error);
        return {
            success: false,
            data: error.response?.data || { message: "Delete Notification failed" },
            status: error.response?.status || 500
        };
    }
};